module.exports = __webpack_public_path__ + "static/img/about02.7b7bf1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about02.png
// module id = OsSo
// module chunks = 1